// extracted by mini-css-extract-plugin
export default {"container":"CompareBox_container__uft4e","label":"CompareBox_label__0qYNA","checkbox":"CompareBox_checkbox__krpea","checkboxContainer":"CompareBox_checkboxContainer__JSDn1"};